export const DEFAULT_HERO_IMAGES = {
  home: "https://static.prod-images.emergentagent.com/jobs/f1709a2f-c779-4c95-b97b-a79ff3440ce0/images/4bbf62178ce7686a0fcb7c624d19d6a7e428b25325b48bb1b5b99f6e3d51e140.jpeg",
  dashboard: "https://static.prod-images.emergentagent.com/jobs/f1709a2f-c779-4c95-b97b-a79ff3440ce0/images/3cd9c145cba8fe36a431c14564c8a4e4119bf69f05d6860d922919952f675ca5.jpeg",
  chisiamo: "https://static.prod-images.emergentagent.com/jobs/f1709a2f-c779-4c95-b97b-a79ff3440ce0/images/3200dbb6de003c9cba3783768ae3ff0d8c1c90940ccc47d36900cabfd9364820.jpeg",
  strumenti: "https://static.prod-images.emergentagent.com/jobs/f1709a2f-c779-4c95-b97b-a79ff3440ce0/images/c73085404554ca491a393f3cb93d40a0f649b1a59d22e90dcc79e0b73f6608bb.jpeg",
  cta: "https://static.prod-images.emergentagent.com/jobs/f1709a2f-c779-4c95-b97b-a79ff3440ce0/images/74966def0418beaec0d24acc1fdba04d41c5eed732fbfc729bbd9ac8dbcf6c7f.jpeg",
  servizi: "https://static.prod-images.emergentagent.com/jobs/f1709a2f-c779-4c95-b97b-a79ff3440ce0/images/0a269c6e2cad200b76705440391dd26c874e8c084fb3066b9f458a14d35a82c8.jpeg",
  calendario: "https://static.prod-images.emergentagent.com/jobs/f1709a2f-c779-4c95-b97b-a79ff3440ce0/images/c520c1f45934a7a67b77683ff71b7a528539f71d25f05b51bcefe143ebd9a248.jpeg",
};

export const HERO_IMAGES = { ...DEFAULT_HERO_IMAGES };

export const HERO_LABELS = {
  home: "Home / Link Utili / Diventa Studente",
  dashboard: "Dashboard / Impostazioni",
  chisiamo: "Chi Siamo",
  strumenti: "Strumenti / Calc. Rischio",
  cta: "CTA finale / Int. Composto",
  servizi: "Percorso e Servizi",
  calendario: "Calendario Economico / Calc. Profitto",
};

export const resolveHeroUrl = (url) =>
  url && url.startsWith("/api") ? `${process.env.REACT_APP_BACKEND_URL}${url}` : url;

export function applyHeroOverrides(overrides) {
  Object.keys(DEFAULT_HERO_IMAGES).forEach((key) => {
    const val = overrides && overrides[key];
    HERO_IMAGES[key] = val ? resolveHeroUrl(val) : DEFAULT_HERO_IMAGES[key];
  });
}

export default function PageHero({ image, kicker, title, subtitle }) {
  return (
    <div className="page-hero" data-testid="page-hero">
      <div className="page-hero-img" style={{ backgroundImage: `url(${image})` }} />
      <div className="page-hero-overlay" />
      {(kicker || title) && (
        <div className="container relative h-full flex flex-col justify-end pb-8">
          {kicker && <p className="hero-kicker">{kicker}</p>}
          {title && (
            <h1 className="display-title" style={{ fontSize: "clamp(2.2rem, 6vw, 4.6rem)", color: "#FFFFFF" }}>
              {title}
            </h1>
          )}
          {subtitle && <p className="text-base mt-2 max-w-xl" style={{ color: "rgba(255,255,255,0.75)" }}>{subtitle}</p>}
        </div>
      )}
    </div>
  );
}
